var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4623 0.441373C15.392 0.528526 15.3362 0.632215 15.2982 0.746458C15.2601 0.860701 15.2405 0.983237 15.2405 1.107C15.2405 1.23076 15.2601 1.3533 15.2982 1.46754C15.3362 1.58178 15.392 1.68547 15.4623 1.77262L18.9123 6.08512H1.25732C1.05841 6.08512 0.867646 6.1839 0.726994 6.35971C0.586342 6.53553 0.507324 6.77398 0.507324 7.02262C0.507324 7.27126 0.586342 7.50972 0.726994 7.68554C0.867646 7.86135 1.05841 7.96012 1.25732 7.96012H18.8973L15.4623 12.2445C15.3226 12.4202 15.2442 12.6578 15.2442 12.9054C15.2442 13.1531 15.3226 13.3907 15.4623 13.5664C15.6028 13.741 15.7929 13.839 15.9911 13.839C16.1892 13.839 16.3793 13.741 16.5198 13.5664L21.2898 7.60387C21.354 7.52688 21.4051 7.43445 21.44 7.33215C21.4749 7.22984 21.4929 7.11978 21.4929 7.00856C21.4929 6.89735 21.4749 6.78728 21.44 6.68498C21.4051 6.58267 21.354 6.49024 21.2898 6.41325L16.5273 0.441373C16.4576 0.353503 16.3747 0.283759 16.2833 0.236163C16.1919 0.188567 16.0938 0.164063 15.9948 0.164062C15.8958 0.164063 15.7978 0.188567 15.7064 0.236163C15.615 0.283759 15.532 0.353503 15.4623 0.441373Z",
    fill: "#97A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.e864d2fbf425872bf56ce76ee03346b1.svg";
export { ForwardRef as ReactComponent };